/**
 * ! This component/file or some other components/files that use this component/file is being shared in one or more micro-frontend.
 * ! Please be careful when editing this component. Make sure to run "yarn build:dev" and check if the "build/@types/index.d.ts" file
 * ! is being generated or not without any errors.
 */
import React, { memo } from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';

import { useStyles } from './styles';

export interface ICheckboxProps {
  name: string;
  value: string | boolean;
  isChecked: boolean;
  inputProps?: any;
  disabled?: boolean;
  error?: boolean;
  testId?: string;
  styleClass?: string;
  onChange: (data: any) => void;
}

const ControlledCheckbox = ({ name, value, isChecked, inputProps = {}, error = false, disabled = false, testId, styleClass, onChange }: ICheckboxProps) => {
  const styles = useStyles();
  return (
    <Checkbox
      icon={<CheckBoxOutlineBlankIcon classes={{ root: `${styles.iconRoot} ${error ? styles.iconRootError : ''}` }} />}
      checkedIcon={<CheckBoxIcon />}
      checked={isChecked}
      onChange={onChange}
      name={name}
      value={value}
      data-testid={testId ?? 'multiple-checkbox'}
      inputProps={{ ...inputProps }}
      disabled={disabled}
      className={styleClass}
    />
  );
};

export default memo(ControlledCheckbox);
